import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { environment } from "src/environments/environment"
import { AverageMonthlyIncome, ModifyObject, CreateAverageMonthlyIncome } from "../models"

@Injectable({
    providedIn: "root",
})
export class AverageMonthlyIncomeService {
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.averageMonthlyIncome

    constructor(private _http: HttpClient) { }

    GetAllAverageMonthlyIncome() {
        return this._http.get<AverageMonthlyIncome[]>(this._apiUrl)
    }

    GetAverageMonthlyIncome(countryCode: string): Observable<AverageMonthlyIncome[]> {
        return this._http.get<AverageMonthlyIncome[]>(this._apiUrl + `/${countryCode}`)
    }

    CreateAverageMonthlyIncome(averageMonthlyIncome: CreateAverageMonthlyIncome): Observable<AverageMonthlyIncome[]> {
        return this._http.post<AverageMonthlyIncome[]>(this._apiUrl, averageMonthlyIncome)
    }

    ModifyAverageMonthlyIncome(masterId: string, modifyObject: ModifyObject): Observable<any> {
        return this._http.patch(this._apiUrl + `/${masterId}`, modifyObject)
    }

    Delete(masterId: string): Observable<string> {
        return this._http.delete<string>(this._apiUrl + `/${masterId}`)
    }
}
